const goToNewQuiz = (state) => {
  return {
    ...state, 
    alert: false, 
    alertStatus: null
  }
}

export default goToNewQuiz